import { useQuery, UseQueryResult } from 'react-query';

import { useAuth } from 'src/hooks';
import { getAlertRevisionsDetails } from 'src/utils/urls';

import { AccountAlertResponse } from 'src/features/PersonAlerts/types/accountAlerts';

export async function fetchAlertRevisionsDetails({
  token,
  tokenType,
  accountId,
  revisionId,
}: TVariables): Promise<TResult | null> {
  const response = await fetch(
    getAlertRevisionsDetails(accountId, revisionId),
    {
      method: 'GET',
      headers: {
        Authorization: `${tokenType} ${token}`,
      },
    },
  );
  return response.json();
}

export type TVariables = {
  token: string;
  tokenType: string;
  accountId: number;
  revisionId: any;
};
export type TError = { message: string };
export type TResult = Array<AccountAlertResponse>;

function useGetAlertRevisionsDetails(
  accountId: number | undefined,
  revisionId: string | null | undefined,
  //   isEnable: boolean,
): UseQueryResult<TResult, TError> {
  const { token, tokenType } = useAuth();
  const revisionIds: number[] = revisionId
    ? revisionId
        .toString()
        .split(',')
        .map((id: string) => parseInt(id.trim(), 10))
        .filter((id: number) => !isNaN(id))
    : [];
  return useQuery(
    ['get_alert_revision_details', accountId, revisionIds],
    async () => {
      if (accountId && revisionIds.length > 0) {
        const results = await Promise.all(
          revisionIds.map(id =>
            fetchAlertRevisionsDetails({
              token,
              tokenType,
              accountId,
              revisionId: id,
            }),
          ),
        );
        return results;
      }
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
      //   enabled: isEnable,
    },
  );
}

export { useGetAlertRevisionsDetails };
